// Guard against Figma iframe popstate events crashing React Router.
// Figma's preview iframe fires popstate events externally (via navigateToUrl),
// which can hit React Router's handlePop before route matching is ready,
// causing "Cannot read properties of undefined (reading 'element')".
//
// This patches window.addEventListener so that any 'popstate' listener
// registered after this module loads is wrapped in a try-catch.

const _origAddEventListener = window.addEventListener.bind(window);

window.addEventListener = function patchedAddEventListener(
  type: string,
  listener: EventListenerOrEventListenerObject,
  options?: boolean | AddEventListenerOptions,
) {
  if (type === 'popstate' && typeof listener === 'function') {
    const wrappedListener = function safePopstateHandler(this: Window, event: Event) {
      try {
        return listener.call(this, event);
      } catch (err: unknown) {
        // Suppress the specific React Router crash from Figma iframe navigation
        if (
          err instanceof TypeError &&
          err.message?.includes("reading 'element'")
        ) {
          console.warn('[StageFlow] Suppressed Figma iframe popstate error:', err.message);
          return;
        }
        throw err; // Re-throw anything else
      }
    };
    return _origAddEventListener(type, wrappedListener as EventListener, options);
  }
  return _origAddEventListener(type, listener, options);
} as typeof window.addEventListener;

export {};
